import { styled } from 'stitches.config'

export const ProductCardV1 = styled('div', {
  width: '100%',
  maxWidth: '320px',
  borderRadius: '41px',
  background: '$accent-white',
  padding: '$4 $1',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '100%',
  maxHeight: '440px',

  '@bp1': {
    maxHeight: '509px',
  },

  '@bp2': {
    padding: '$4 $1',
    maxWidth: 'none',
    aspectRatio: '1 / 1',
    maxHeight: '496px',
  },
})

export const ProductCard = styled(ProductCardV1, {
  maxWidth: '328px',
  maxHeight: 'none',
  height: '382px',
  backgroundColor: '$tertiary-200',

  '@bp3': {
    maxWidth: '564px',
    height: '496px',
  },
})

export const PriceWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
  marginBottom: '$1',
})

export const OriginalPrice = styled('span', {
  color: '$accent-black',
  textDecoration: 'line-through',
  fontSize: '$bodyLarge',
  textDecorationColor: '$primary-500',
})

export const DiscountedPrice = styled('span', {
  color: '$primary-500',
  fontSize: '$bodyLarge',
  fontWeight: '$semiBold',
})

export const ProductImageV1 = styled('div', {

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '$2',
  position: 'relative', 
  
  
  height: '192px',
  width: '217px',

  '& img': {
    objectFit: 'contain',
    borderRadius: '20px',
  },

  '@bp2': {height: '260px',
   width: '293px',
    marginBottom: '$4',
  },

})

export const ProductImage = styled(ProductImageV1, {
  '& img': {
    borderRadius: 0,
  },
  margin: 0,
  height: 'auto',
  marginBottom: '$3',
  width: '100%',

  '&.small-box': {
    maxWidth: '190px',
    marginBottom: '$5',
  },
  '&.classic-box': {
    maxWidth: '240px',
    marginBottom: '$3',
  },
  '&.big-box': {
    maxWidth: '290px',
    marginBottom: '$1',
  },

  '@bp3': {
    '&.small-box': {
      marginBottom: '$3',
      maxWidth: '300px',
    },
    '&.classic-box': {
      marginBottom: '$3',
      maxWidth: '370px',
    },
    '&.big-box': {
      marginBottom: '$3',
      maxWidth: '430px',
    },
  },
})

export const ProductsGridV1 = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$6',
  alignItems: 'center',
  zIndex: 2,

  '@bp2': {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '$3',
  },

  '@bp3': {
    gap: '$6',
  },
})

export const ProductsGrid = styled(ProductsGridV1, {
  flexWrap: 'wrap',
  marginBottom: '$4',
  '@bp3': {
    gap: '$3',
  },
  '@bp4': {
    flexWrap: 'nowrap',
  },
})

export const HeaderWrapper = styled('div', {
  margin: 'auto',
  marginTop: '$6',
  marginBottom: '$3',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$2',
  width: '100%',
  maxWidth: '371px',

  '@bp3': {
    maxWidth: '700px',
  },
})

export const ProductTitleWrapper = styled('div', {

  textAlign: 'center',
  marginBottom: '$1',

  '@bp2': {
    marginBottom: '$3',
  },
})

export const CtaWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-end',
  height: '100%',
})

export const ProductCatalogRoot = styled('section', {
  background: '$accent-white',
  paddingTop: '$4',
  paddingBottom: '$4',
  paddingLeft: '12px',
  paddingRight: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',
  zIndex: 0,
  position: 'relative',

  '@bp1': {
    padding: '$4 $2 $2 $2'
  },

  '@bp2': {
    padding: '$6 $4 $4 $4',
  },
})


export const ProductCta = styled('div', {
  width: '190px',
  display: 'flex',
  justifyContent: 'center',

  '@bp2': {
    width: '243px',
  },

  '&.desktop-only': {
    display: 'none',
    '@bp2': { display: 'flex' }
  },
  '&.mobile-only': {
    display: 'flex',
    '@bp2': { display: 'none' }
  },

  '& button': {
    width: '100%',
  }
})